$("#CollectionSection .collection-sidebar__group").each(function(){
     $(this).removeClass("hide");
     if($(this).find(".tag-list li.tag").hasClass("hide")){
        $(this).addClass("hide");
      }
});


 $(window).on("load resize",function(e){
var width = $(window).width();
    if(width > 769){
  $(".collection-main-jtpl").find(".filter-form").removeClass("filter-form").addClass("filter-form-desktop");      
      $(".drawer__scrollable").find(".filter-form-desktop").removeClass("filter-form-desktop").addClass("filter-form");
  
    }else{
        $(".drawer__scrollable").find(".filter-form").removeClass("filter-form").addClass("filter-form-desktop");
   $(".collection-main-jtpl").find(".filter-form-desktop").removeClass("filter-form-desktop").addClass("filter-form");      
  }
 
 });

// form popop in home page js start

// $(document).ready(function(){
//     $("#formButton").click(function(){
//         $("#form1").toggle();
//     });
// });


$(".custom-image-upload-bnt-jtpl").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".custom-close-btn-jtpl, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
  $("body").removeClass('custom_upload_image_form_popop_jtpl')
});


 $(".custom-image-upload-bnt-jtpl").click(function(){
    $("body").addClass("custom_upload_image_form_popop_jtpl");
  });
  $(".custom-close-btn-jtpl").click(function(){
    $("body").removeClass("custom_upload_image_form_popop_jtpl");
  });

// form popop in home page js end
 
// $(window).on("load resize scroll",function(e){
   
//  $.get("/collections/all?view=filters", function(data, status){
//     var width = $(window).width();
//    console.log(data);
//    console.log(width);
//      if(width < 768){
//      $("#mobile-filters").html(data);
//      $("#desktop-filters").html('');
//   }else{
//        $("#desktop-filters").html(data);
//      $("#mobile-filters").html('');
//   }
//   });
 
// });


// $(".collection-main-jtpl .text-label").click(function(){
// alert(1);
// $(this).parent(".tag").toggleClass("tag--active");
// });
$(document).ready(function(){


$(".site-nav--is-megamenu").hover(
  function () {
    $(this).addClass("result_hover");
  },
  function () {
    $(this).removeClass("result_hover");
  }
);
  
  var mainImgVdoHeight = $('.image-wrap .contact-us__content').height();
  $('.jtpl_video_img_section .image-wrap video').css('height', mainImgVdoHeight);
});

// TEST BUTTON IFRAME
let btn_glow_club=document.querySelector('#glowClubHeadBtn');
if(btn_glow_club){
  btn_glow_club.addEventListener('click',(c)=>{
      c.preventDefault();
      let ie=document.querySelector('#smile-ui-lite-container iframe');
      if(!ie){
        ie=document.querySelector('#smile-ui-container iframe');
        if(!ie){return;}
      }
      let ic=ie.contentDocument;
      if(!ic){return;}
      let btn=ic.querySelector('button[aria-label]');
      if(!btn){return;}
      btn.click();
  });
}
